(() => {
  if (window.__easifyCartDrawerPatch) return;
  window.__easifyCartDrawerPatch = true;

  const REFRESH_AFTER_PAINT_MS = [200, 900];
  const LINE_ROW_SELECTOR =
    'cart-drawer .cart-item:not(.is-addon-item):not(.cart-item__nested-line)';

  function getLineRows() {
    return document.querySelectorAll(LINE_ROW_SELECTOR);
  }

  function patchCartDrawerIntegration() {
    window.TPOCustomFunctions = window.TPOCustomFunctions || {};
    const base = window.TPOCustomFunctions.cartDrawer || {};

    window.TPOCustomFunctions.cartDrawer = {
      ...base,
      getCartContainer() {
        return document.querySelector('cart-drawer') || document.querySelector('#CartDrawer');
      },
      getItemContainer(lineIndex) {
        return getLineRows().item(lineIndex) ?? null;
      },
      getItemRenderEditOptions(lineIndex) {
        const row = window.TPOCustomFunctions.cartDrawer.getItemContainer(lineIndex);
        if (!row) return null;

        const details = row.querySelector('.cart-item__details');
        if (!details) return null;

        let slot = details.querySelector(':scope > .tpo-edit-options-container');
        if (!slot) {
          slot = document.createElement('div');
          slot.className = 'tpo-edit-options-container';
          const dl = details.querySelector('dl');
          if (dl) dl.insertAdjacentElement('afterend', slot);
          else details.appendChild(slot);
        }
        return slot;
      },
    };
  }

  function dedupeEditLinks() {
    document.querySelectorAll('.cart-drawer .tpo-edit-options-container').forEach((slot) => {
      const controls = slot.querySelectorAll('a, button, [role="button"]');
      for (let i = 1; i < controls.length; i += 1) controls[i].remove();
    });

    document.querySelectorAll('.cart-drawer .cart-item:not(.is-addon-item)').forEach((row) => {
      let seen = false;
      row.querySelectorAll('a, button, [role="button"]').forEach((el) => {
        const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!/^edit options$/i.test(text)) return;
        if (seen) {
          (el.closest('.tpo-edit-options-container, [class*="po-"]') || el).remove();
        } else {
          seen = true;
        }
      });
    });
  }

  function refresh() {
    patchCartDrawerIntegration();
    if (typeof window.loadDeferredEasifyScripts === 'function') {
      window.loadDeferredEasifyScripts();
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
    dedupeEditLinks();
  }

  function afterDrawerPainted() {
    patchCartDrawerIntegration();
    REFRESH_AFTER_PAINT_MS.forEach((ms) => setTimeout(refresh, ms));
  }

  let openRefreshTimer;

  function refreshWhenDrawerOpens() {
    clearTimeout(openRefreshTimer);
    openRefreshTimer = setTimeout(refresh, 450);
  }

  patchCartDrawerIntegration();
  document.addEventListener('DOMContentLoaded', patchCartDrawerIntegration);

  window.EasifyCartDrawer = {
    refresh,
    afterDrawerPainted,
    dedupeEditLinks,
    refreshWhenDrawerOpens,
  };
})();
